function loadTemplate(template, data, options) {
    var el = $('<div/>');
    return el.loadTemplate($(template), data, options).html();
}